import { useSnackbar } from 'notistack';

let snackbarRef: any = null;

export const SnackbarUtilsConfigurator = () => {
  snackbarRef = useSnackbar();
  return null;
};

export const enqueueSnackbar = (message: string, options: any = {}) => {
  if (snackbarRef?.enqueueSnackbar) {
    snackbarRef.enqueueSnackbar(message, options);
  } else {
    console.warn(
      'Snackbar not initialized. Make sure SnackbarUtilsConfigurator is included in your app.',
    );
  }
};

export const closeSnackbar = (key?: string | number) => {
  if (snackbarRef?.closeSnackbar) {
    snackbarRef.closeSnackbar(key);
  }
};
